module.exports = __webpack_public_path__ + "img/国防科技大学外国语学院.92182470.png";